import { Component, Input, OnInit } from '@angular/core';
import { EarnPointsCardModel } from '@fgb/core';

@Component({
  selector: 'fgbcl-earn-points-card',
  templateUrl: './earn-points-card.component.html',
  styleUrls: ['./earn-points-card.component.scss'],
})
export class EarnPointsCardComponent implements OnInit {
  constructor() {}

  @Input() earnPointsCard: EarnPointsCardModel;

  ngOnInit(): void {}
}
